import { OnSuccessFct } from '../types';
import {
  useDestSchoolSchoolyear,
  useFromValue,
  useSelectedPreviewSeances,
  useSrcSchoolSchoolyear,
  useToValue,
} from '../atom';
import { useGetDaysWithEvents } from 'containers/CahierJournal/queries/useGetDaysWithEvents';
import { useCopyCJSeances } from 'containers/CahierJournal/queries/useCopyCJSeances';
import { SubmitButton } from '../SubmitButton';
import isSameDay from 'utils/time/isSameDay';
import React from 'react';
import { Footer } from '.';
import { useTranslation } from 'react-i18next';
import _sortBy from 'lodash-es/sortBy';

interface Props {
  onClose: () => void;
  ctaTitle?: (v: Date, nbOfSelectedSeances?: number) => void;
  disabled?: boolean;
  onSuccess?: OnSuccessFct;
}

export function FooterWrapper(props: Props) {
  const { onClose, onSuccess } = props;
  const selectedSeances = useSelectedPreviewSeances();
  const { t } = useTranslation(['common', 'cahierJournal']);
  const from = useFromValue();
  const to = useToValue();
  const { schoolyear: srcSchoolyear, school: srcSchool } =
    useSrcSchoolSchoolyear();
  const { schoolyear: destSchoolyear, school: destSchool } =
    useDestSchoolSchoolyear();

  const { data, isInitialLoading, isLoading } = useGetDaysWithEvents({
    schoolId: srcSchool?.id,
    schoolyearId: srcSchoolyear?.id,
  });

  const [copyEvents, isCopying] = useCopyCJSeances();
  return (
    <Footer daysWithEvents={data} onClose={onClose}>
      <SubmitButton
        srcSchool={srcSchool}
        srcSchoolyear={srcSchoolyear}
        destSchool={destSchool}
        destSchoolyear={destSchoolyear}
        ctaTitle={nbOfSelectedSeances => {
          if (nbOfSelectedSeances === 1) {
            return t(
              'cahierJournal:copyEventsToAnotherDayModal.footer.copySeance_one',
            );
          }
          if ((nbOfSelectedSeances || 0) > 0) {
            return t(
              'cahierJournal:copyEventsToAnotherDayModal.footer.copySeance_other',
            );
          }
          return t('cahierJournal:copyEventsToAnotherDayModal.footer.copyDay');
        }}
        loading={isCopying}
        disabled={
          !(from && to) ||
          isLoading ||
          isInitialLoading ||
          !(data || []).some(d => isSameDay(d, from))
        }
        onSubmit={classroomsMapping => {
          const eventIds =
            (selectedSeances || []).length > 0
              ? selectedSeances.map(ev => ev.id)
              : undefined;
          copyEvents({
            from,
            to,
            classroomsMapping,
            eventIds,
            srcSchoolId: srcSchool?.id!,
            srcSchoolyearId: srcSchoolyear?.id!,
            destSchoolId: destSchool?.id!,
            destSchoolyearId: destSchoolyear?.id!,
          }).then(({ data: newEvents }) => {
            if (onSuccess) {
              onSuccess({
                to,
                eventIds,
                newEventIds: _sortBy(newEvents, e => e.start).map(
                  e => e.id.split('-')[0],
                ),
                destSchool: destSchool!,
                destSchoolyear: destSchoolyear!,
              });
            }
            onClose();
          });
        }}
      />
    </Footer>
  );
}
